module.exports = __webpack_public_path__ + "static/ContinuousSpray-01c87b12aa96259fff55b6e6e179c262.svg";